var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contacts-map-row"},[(!_vm.mapHidden)?_c('yandex-map',{staticStyle:{"width":"100%","max-width":"100%","height":"460px"},attrs:{"zoom":"15","coords":_vm.coords,"scroll-zoom":false}},[_c('ymap-marker',{attrs:{"marker-id":"1","coords":_vm.coords,"hint-content":_vm.hintContent,"balloon-template":_vm.hintContent}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }